import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class RecommendedSearches extends PaginatedStore {
  constructor(scope) {
    super(new Connection('recommended_searches', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/recommended_searches.js